import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@panel/commons/hooks';
import { Step1Module1Selectors, Step1Module1Operations } from '../../ducks/step1Module1';
import { Step1Module2Selectors, Step1Module2Operations } from '../../ducks/step1Module2';
import { useStepperCtx } from '../stepper';
import { Container, Title, Item } from './styles';

const FeedbackBox = () => {
  const { propertyTypes, propertySubTypes, formValues } = useSelector(Step1Module1Selectors.getStep1Module1State);
  const locationValues = useSelector(Step1Module2Selectors.getStep1Module2State);
  const [postingId] = useQuery(useLocation(), ['postingId']);
  const { currentStep, moduleName } = useStepperCtx();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const operationTypeOptions = {
    '1': t(`publisher.step1.module1.operationType.1`),
    '2': t(`publisher.step1.module1.operationType.2`),
    '4': t(`publisher.step1.module1.operationType.4`)
  };
  const { selectedOperationTypeId, selectedPropertyTypeId, selectedPropertySubTypeId } = formValues;
  const operationType = operationTypeOptions[selectedOperationTypeId];
  const propertyType = propertyTypes && propertyTypes.find(p => p.realEstateTypeId === selectedPropertyTypeId);
  const propertyTypeName = propertyType && propertyType.name;
  const propertySubType =
    propertySubTypes && propertySubTypes.find(p => p.realEstateSubTypeId === selectedPropertySubTypeId);
  const propertySubTypeName = propertySubType && propertySubType.name;
  const selectedProvince = locationValues.formValues.selectedProvince
    ? locationValues.formValues.selectedProvince.name
    : locationValues.hasLocation && locationValues.hasLocation.parent && locationValues.hasLocation.parent.parent.name;

  useEffect(() => {
    if (postingId) {
      if (
        (currentStep > 1 && !operationType) ||
        (currentStep === 1 && moduleName !== 'operacionypropiedad' && !operationType)
      ) {
        const requestOperation = {
          module: 'OPERATION',
          step: 'STEP_MAIN',
          postingId
        };
        dispatch(Step1Module1Operations.getPropertyTypes());
        dispatch(Step1Module1Operations.getFormValues(requestOperation));
      }
      if (operationType && propertySubTypes === null) {
        dispatch(Step1Module1Operations.getPropertySubTypes(selectedPropertyTypeId));
      }
      if (
        (currentStep > 1 && !selectedProvince) ||
        (currentStep === 1 && moduleName !== 'operacionypropiedad' && moduleName !== 'ubicacion' && !selectedProvince)
      ) {
        const requestOperationLocation = {
          module: 'ADDRESS',
          step: 'STEP_MAIN',
          postingId
        };
        dispatch(Step1Module2Operations.getFormValues(requestOperationLocation));
      }
    }
  }, [
    postingId,
    currentStep,
    moduleName,
    operationType,
    selectedProvince,
    dispatch,
    propertySubTypes,
    selectedPropertyTypeId
  ]);

  return (
    <Container data-repa='feedbackBox-container' visible={operationType && moduleName !== 'operacionypropiedad'}>
      <Title data-repa='feedbackBox-title'>{t(`publisher.feedbackbox.title`)}</Title>
      {operationType && (
        <Item data-repa='feedbackBox-title-icon' icon='operation'>
          <span />
          <p data-repa='feedbackBox-title-label'>{operationType}</p>
        </Item>
      )}
      {propertyTypeName && (
        <Item data-repa='feedbackBox-title-propertyName-icon' icon='property'>
          <span />
          <p data-repa='feedbackBox-title-propertyName-label'>{`${propertyTypeName} ${propertySubTypeName || ''}`}</p>
        </Item>
      )}
      {selectedProvince && moduleName !== 'ubicacion' && (
        <Item data-repa='feedbackBox-title-location-icon' icon='location'>
          <span />
          <p data-repa='feedbackBox-title-location-label'>{selectedProvince}</p>
        </Item>
      )}
    </Container>
  );
};

export { FeedbackBox };
